import { contextPromise } from '@web-platform/shared-banana-utils-frontend/src/helpers/contextPromise';
import { LOGGING } from '@web-platform/shared-universal-constants/src/logging';
import DisplayError from '@web-platform/shared-universal-features-components/src/DisplayError/DisplayError';
import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { waitForNewRelicAgentScript } from '@web-platform/shared-universal-utils-frontend/src/helpers/waitForNewRelicAgentScript';
import { createRoot } from 'react-dom/client';
import { GLOBAL, redirect } from 'saddlebag-browser';

import type { ContextResponse } from '@web-platform/shared-universal-types/src/context';

const $window: Window = GLOBAL.getWindow();

const component = 'context-call';

export const handleContextError = (error: Error) => {
  // Rely on granular component level houston alerting. Avoid logging errors that would trigger individual page owners' error alerts, but do log warnings for debug information.
  logWarn({
    component,
    error: error.toString(),
    message: `Failed retrieving context. ${LOGGING.HOUSTON_REDIRECT}`,
    userAgentString: $window.navigator.userAgent,
  });

  if (process.env.NODE_ENV !== 'production') {
    const container = GLOBAL.getDocument().getElementById('app-root');

    const root = createRoot(container);
    root.render(
      <DisplayError errorName={error.message} originPage={component} stackTrace={error.stack} />,
    );
  } else {
    const prevPageGroup = $window.__internal?.initialPageGroup;

    const houstonPage = `/500.ashx?source=${LOGGING.PAGE_NAME}&component=${component}&prevPageGroup=${prevPageGroup}`;
    waitForNewRelicAgentScript(() => redirect(houstonPage));
  }
};

export const getContextAndHandleError = async () => {
  try {
    const contextResponse = await contextPromise();
    const { context }: ContextResponse = JSON.parse(contextResponse);
    return context;
  } catch (error) {
    handleContextError(error);
    return null;
  }
};
